module.exports = __webpack_public_path__ + "static/media/YM89_6.14ac265f.jpg";